import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const SystemIcon = ({ linkUrl, icon, themeColorHex, onClick, iconSizeClass }) => (
  <span
    onClick={onClick}
    className={`icon-wrapper system-icon ${iconSizeClass} ${!linkUrl ? 'disabled' : ''}`}
    style={{ backgroundColor: themeColorHex }} >
    <span className={`icon ${icon}`} />
  </span>
)

SystemIcon.propTypes = {
  linkUrl: PropTypes.string,
  icon: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  iconSizeClass: PropTypes.string
}

export default SystemIcon
